import axiosConfig from "./axiosConfig";

export interface MappingToCommit {
  fileGuid: string;
  siteId: string;
  esys: string;
}

export interface CommitMappingsRequest {
  mappings: MappingToCommit[];
}

export interface CommittedMapping {
  fileGuid: string;
  siteId: string;
  esys: string;
  hhDemandGuid: string;
}

export interface FailedMapping extends MappingToCommit {
  error: string;
}

// The eventual commit result, read from the LRO operation result via /async_status.
export interface CommitMappingsResponse {
  committed: CommittedMapping[];
  failed: FailedMapping[];
}

// Each mapping triggers a full site recompute, which exceeds the API Gateway budget for a
// batch, so the POST kicks off a tier-2 LRO and returns a handle to poll.
export interface CommitMappingsKickoff {
  operationKey: string;
  siteId: string;
  status: string;
}

const postHhDataCommitMappings = async (
  authToken: string,
  request: CommitMappingsRequest
): Promise<CommitMappingsKickoff> => {
  const { data } = await axiosConfig.post("/hh_data/commit_mappings", request, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default postHhDataCommitMappings;
